<template>
  <div>
    <h6
      class="heading-small text-muted mb-4 text-truncate"
      style="padding: 1rem; border-bottom: 1px solid #e9ecef"
    >
      User Group Management
    </h6>

    <form id="form-proper">
      <div class="row">
        <div class="col">
          <a-steps :current="currentStep">
            <a-step title="User Group" />
            <a-step title="System Modules" />
          </a-steps>
          <br />

          <div v-if="currentStep == 0">
            <div class="row">
              <div class="col">
                <base-input label="Name" required>
                  <a-input
                    v-model="userGroupFormData.name"
                    :disabled="viewMode"
                  />
                </base-input>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-input label="Description">
                  <a-textarea
                    v-model="userGroupFormData.description"
                    :auto-size="{ minRows: 3, maxRows: 3 }"
                    :disabled="viewMode"
                /></base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input label="Code" required>
                  <a-input
                    v-model="userGroupFormData.code"
                    :disabled="viewMode || userGroupData !== null"
                    @input="
                      userGroupFormData.code = $event.target.value.toUpperCase()
                    "
                  />
                </base-input>
              </div>
            </div>
          </div>

          <div v-if="currentStep == 1">
            <div>
              <a-checkbox
                :key="'select-all-'"
                :disabled="viewMode"
                :checked="isAllModulesSelected"
                @change="selectAllModules"
              >
                Select All Modules
              </a-checkbox>
            </div>
            <div>
              <b-tabs pills card vertical nav-class="px-0">
                <b-tab
                  title-item-class="p-0 w-100 m-0"
                  title="All Modules"
                  active
                >
                  <b-card-text style="height: 53vh; overflow: auto">
                    <a-collapse v-model="activeKey">
                      <a-collapse-panel
                        :key="module.id + ''"
                        v-for="module in filteredSystemModules"
                      >
                        <template #header>
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                            "
                          >
                            <span>{{ module.name }}</span>
                            <a-checkbox
                              :key="'select-all-' + module.id"
                              :disabled="viewMode"
                              :checked="
                                isAllSelected(
                                  module.id,
                                  module.actions.split('|')
                                )
                              "
                              @change="
                                onSelectAll(
                                  $event,
                                  module.id,
                                  module.actions.split('|')
                                )
                              "
                            >
                              Select All
                            </a-checkbox>
                          </div>
                        </template>

                        <div class="col">
                          <div class="row">
                            <a-checkbox-group
                              :name="module.name"
                              @change="onSelectAccess($event, module.id)"
                              :default-value="selectedModuleAccess(module.id)"
                              v-model="selectedActions[module.id]"
                            >
                              <div class="d-flex flex-wrap">
                                <a-checkbox
                                  class="p-2 flex-fill m-0"
                                  v-for="action in module.actions.split('|')"
                                  :key="action"
                                  :disabled="viewMode"
                                  :value="action"
                                >
                                  {{ action }}</a-checkbox
                                >
                              </div>
                            </a-checkbox-group>
                          </div>
                        </div>
                      </a-collapse-panel>
                    </a-collapse>
                  </b-card-text>
                </b-tab>
                <b-tab
                  v-if="!hasCardAssignmentModule"
                  title-item-class="p-0 w-100 m-0"
                  title="Card Management (with Card Orders)"
                >
                  <b-card-text style="height: 53vh; overflow: auto">
                    <a-collapse v-model="activeKey">
                      <a-collapse-panel
                        :key="module.id + ''"
                        v-for="module in cardManagementWithCardOrders"
                      >
                        <template #header>
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                            "
                          >
                            <span>{{ module.name }}</span>
                            <a-checkbox
                              :key="'select-all-' + module.id"
                              :disabled="viewMode"
                              :checked="
                                isAllSelected(
                                  module.id,
                                  module.actions.split('|')
                                )
                              "
                              @change="
                                onSelectAll(
                                  $event,
                                  module.id,
                                  module.actions.split('|')
                                )
                              "
                            >
                              Select All
                            </a-checkbox>
                          </div>
                        </template>
                        <div class="col">
                          <div class="row">
                            <a-checkbox-group
                              :name="module.name"
                              @change="onSelectAccess($event, module.id)"
                              :default-value="selectedModuleAccess(module.id)"
                              v-model="selectedActions[module.id]"
                            >
                              <div class="d-flex flex-wrap">
                                <a-checkbox
                                  class="p-2 flex-fill m-0"
                                  v-for="action in module.actions.split('|')"
                                  :key="action"
                                  :disabled="viewMode"
                                  :value="action"
                                >
                                  {{ action }}</a-checkbox
                                >
                              </div>
                            </a-checkbox-group>
                          </div>
                        </div>
                      </a-collapse-panel>
                    </a-collapse>
                  </b-card-text>
                </b-tab>
                <b-tab
                  v-if="hasCardAssignmentModule"
                  title-item-class="p-0 w-100 m-0"
                  title="Card Management (Direct Assignment)"
                >
                  <b-card-text style="height: 53vh; overflow: auto">
                    <a-collapse v-model="activeKey">
                      <a-collapse-panel
                        :key="module.id + ''"
                        v-for="module in cardManagementDirectAssignment"
                      >
                        <template #header>
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                            "
                          >
                            <span>{{ module.name }}</span>
                            <a-checkbox
                              :key="'select-all-' + module.id"
                              :disabled="viewMode"
                              :checked="
                                isAllSelected(
                                  module.id,
                                  module.actions.split('|')
                                )
                              "
                              @change="
                                onSelectAll(
                                  $event,
                                  module.id,
                                  module.actions.split('|')
                                )
                              "
                            >
                              Select All
                            </a-checkbox>
                          </div>
                        </template>
                        <div class="col">
                          <div class="row">
                            <a-checkbox-group
                              :name="module.name"
                              @change="onSelectAccess($event, module.id)"
                              :default-value="selectedModuleAccess(module.id)"
                              v-model="selectedActions[module.id]"
                            >
                              <div class="d-flex flex-wrap">
                                <a-checkbox
                                  class="p-2 flex-fill m-0"
                                  v-for="action in module.actions.split('|')"
                                  :key="action"
                                  :disabled="viewMode"
                                  :value="action"
                                >
                                  {{ action }}</a-checkbox
                                >
                              </div>
                            </a-checkbox-group>
                          </div>
                        </div>
                      </a-collapse-panel>
                    </a-collapse></b-card-text
                  >
                </b-tab>
                <b-tab
                  v-if="hasCardSellingModule"
                  title-item-class="p-0 w-100 m-0"
                  title="Card Selling"
                >
                  <b-card-text style="height: 53vh; overflow: auto">
                    <a-collapse v-model="activeKey">
                      <a-collapse-panel
                        :key="module.id + ''"
                        v-for="module in cardSellingModules"
                      >
                        <template #header>
                          <div
                            style="
                              display: flex;
                              align-items: center;
                              justify-content: space-between;
                            "
                          >
                            <span>{{ module.name }}</span>
                            <a-checkbox
                              :key="'select-all-' + module.id"
                              :disabled="viewMode"
                              :checked="
                                isAllSelected(
                                  module.id,
                                  module.actions.split('|')
                                )
                              "
                              @change="
                                onSelectAll(
                                  $event,
                                  module.id,
                                  module.actions.split('|')
                                )
                              "
                            >
                              Select All
                            </a-checkbox>
                          </div>
                        </template>
                        <div class="col">
                          <div class="row">
                            <a-checkbox-group
                              :name="module.name"
                              @change="onSelectAccess($event, module.id)"
                              :default-value="selectedModuleAccess(module.id)"
                              v-model="selectedActions[module.id]"
                            >
                              <div class="d-flex flex-wrap">
                                <a-checkbox
                                  class="p-2 flex-fill m-0"
                                  v-for="action in module.actions.split('|')"
                                  :key="action"
                                  :disabled="viewMode"
                                  :value="action"
                                >
                                  {{ action }}</a-checkbox
                                >
                              </div>
                            </a-checkbox-group>
                          </div>
                        </div>
                      </a-collapse-panel>
                    </a-collapse>
                  </b-card-text>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <!-- <div
        style="position: absolute; bottom: 1rem;right: 1.5rem; width: -moz-webkit-fill-available; padding: 10px;"
      > -->
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto" v-if="currentStep == 1">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click="previousStep"
              >
                Back
              </b-button>
            </div>

            <div class="col-auto" v-if="currentStep < 1">
              <template>
                <b-button size="sm" variant="success" @click="nextStep">
                  Next
                </b-button>
              </template>
            </div>
            <div class="col-auto" v-if="currentStep == 1">
              <a-spin :spinning="submittingForm">
                <template>
                  <b-button
                    size="sm"
                    variant="success"
                    :disabled="viewMode || submittingForm"
                    @click="createUserGroup"
                    v-if="userGroupData === null"
                  >
                    Create User Group
                  </b-button>
                  <b-button
                    size="sm"
                    variant="success"
                    :disabled="viewMode || submittingForm"
                    @click="confirmUpdate"
                    v-else
                  >
                    Update User Group
                  </b-button>
                </template>
              </a-spin>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'UserGroupForm',
  props: {
    userGroupData: Object,
    systemModules: Array,
    viewMode: Boolean,
    drawerVisible: Boolean
  },
  data() {
    return {
      disabledModuleDirectAssignment: [
      'CardOrder',
      'CardReceive',
      'CardTransferOut',
      'CardTransferIn',
      'CardType',
      'CardSupplier',
      ],
      currentStep: 0,
      submittingForm: false,
      activeKey: [],
      hasCardSellingModule: false,
      hasCardAssignmentModule: false,
      cardManagementWithCardOrders: [],
      cardManagementDirectAssignment: [],
      cardSellingModules: [],
      selectedActions: {},
      userGroupFormData: {
        name: null,
        description: null,
        code: null
      },
      userGroupSystemModuleFormData: []
    };
  },
  validations: {
    userGroupFormData: {
      name: { required },
      code: { required }
    }
  },
  methods: {
    async getCardSellingFeature() {
      const response = await HTTPRequest.getRequest(
        `/api/v1/clp_accounts/settings/CARD_SELLING_FEATURE`
      );

      if (response.account_id) {
        this.hasCardSellingModule = response.value == 'true';
      }
    },
    async getCardAssignmentFeature() {
      const response = await HTTPRequest.getRequest(
        `/api/v1/clp_accounts/settings/CARD_ASSIGNMENT_FEATURE`
      );

      if (response.account_id) {
        this.hasCardAssignmentModule = response.value == 'true';
      }
    },

    filterModules() {
      const withCardOrdersModules = [
        'CardInventory',
        'CardOrder',
        'CardReceive',
        'CardTransferOut',
        'CardTransferIn',
        'CardType',
        'CardSupplier'
      ];
      const cardSelling = [
        'CardSellingType',
        'PaymentType',
        'CardSellingReport'
      ];
      let sysModules = this.filteredSystemModules;
      this.cardManagementWithCardOrders = sysModules.filter((module) =>
        withCardOrdersModules.includes(module.name)
      );

      this.cardManagementDirectAssignment = sysModules.filter((module) =>
        ['CardInventory'].includes(module.name)
      );
      this.cardSellingModules = sysModules.filter((module) =>
        cardSelling.includes(module.name)
      );
    },
    selectAllModules(checked) {
      this.filteredSystemModules.forEach((module) => {
        const actions = module.actions.split('|');
        if (checked.target.checked) {
          this.$set(this.selectedActions, module.id, [...actions]);
        } else {
          this.$set(this.selectedActions, module.id, []);
        }
        this.onSelectAccess(this.selectedActions[module.id], module.id);
      });

      if (checked.target.checked) {
        this.activeKey = this.filteredSystemModules.map((module) => module.id);
      } else {
        this.activeKey = [];
      }
    },

    isAllSelected(moduleId, actions) {
      const selected = this.selectedActions[moduleId] || [];
      return selected.length === actions.length;
    },
    onSelectAll(checked, moduleId, actions) {
      if (checked.target.checked) {
        this.$set(this.selectedActions, moduleId, [...actions]);
      } else {
        this.$set(this.selectedActions, moduleId, []);
      }
      this.onSelectAccess(this.selectedActions[moduleId], moduleId);
      if (!this.activeKey.includes(moduleId)) {
        this.activeKey.push(moduleId);
      }
    },
    async createUserGroup() {
      this.$v.userGroupFormData.$touch();

      if (!this.$v.userGroupFormData.$invalid) {
        this.submittingForm = true;

        const response = await HTTPRequest.postRequest('/api/v1/user_groups', {
          user_group: this.userGroupFormData,
          user_group_system_module: this.userGroupSystemModuleFormData
        });

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Success',
            description: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.submittingForm = false;
      }
    },

    async editUserGroup() {
      this.$v.userGroupFormData.$touch();

      if (!this.$v.userGroupFormData.$invalid) {
        this.submittingForm = true;

        const response = await HTTPRequest.putRequest(
          '/api/v1/user_groups/' + this.userGroupData.id,
          {
            user_group: this.userGroupFormData,
            user_group_system_module: this.userGroupSystemModuleFormData
          }
        );

        if (response.id) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Success',
            description: 'Data has been updated.'
          });
          // location.reload();
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.submittingForm = false;
      }
    },

    onSelectAccess(selectedActions, moduleId) {
      const _selectedActions = selectedActions.join('|');

      let _userGroupSystemModuleFormData = this.userGroupSystemModuleFormData;

      let obj = _userGroupSystemModuleFormData.find(function (module) {
        if (module.system_module_id == moduleId) return true;
      });

      if (typeof obj === 'undefined') {
        _userGroupSystemModuleFormData.push({
          system_module_id: moduleId,
          selected_actions: _selectedActions
        });
      } else {
        obj.selected_actions = _selectedActions;
      }

      this.userGroupSystemModuleFormData = _userGroupSystemModuleFormData;
    },

    selectedModuleAccess(moduleId) {
      if (this.userGroupSystemModuleFormData.length <= 0) {
        return [];
      }

      let _userGroupSystemModuleFormData = this.userGroupSystemModuleFormData;

      let obj = _userGroupSystemModuleFormData.find(function (module) {
        if (module.system_module_id == moduleId) return true;
      });

      if (typeof obj !== 'undefined') {
        const selectedActions = obj.selected_actions.split('|');
        return selectedActions;
      }

      return [];
    },

    confirmUpdate() {
      this.$confirm({
        title: 'Confirm',
        content: 'Are you sure you want to commit the changes you made?',
        onOk: () => {
          this.editUserGroup();
        }
      });
    },

    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
    },

    clearForm() {
      this.userGroupFormData = {
        name: null,
        description: null,
        code: null
      };

      this.userGroupSystemModuleFormData = [];

      this.currentStep = 0;
      this.activeKey = [];
      this.$v.userGroupFormData.$reset();
    },

    setFormData() {
      if (this.userGroupData !== null) {
        let { name, description, code } = this.userGroupData;
        this.userGroupFormData = [];

        this.getUserGroupSystemModules(this.userGroupData.id);

        this.userGroupFormData = { name, description, code };
      }
    },

    nextStep() {
      this.currentStep++;
    },

    previousStep() {
      this.currentStep--;
    },

    async getUserGroupSystemModules(userGroupId) {
      const data = await HTTPRequest.getRequest(
        '/api/v1/user_group_system_modules/user_group/' + userGroupId
      );

      let _userGroupSystemModules = [];
      if (data.length > 0) {
        for (const module of data) {
          const { system_module_id, selected_actions } = module;
          _userGroupSystemModules.push({ system_module_id, selected_actions });
        }
      }

      this.userGroupSystemModuleFormData = _userGroupSystemModules;
      await this.populateSelectedModuleActions()
    },
    populateSelectedModuleActions() {
      let selectedActions = {};
      let x = 0;
      while (x < this.userGroupSystemModuleFormData.length) {
        let data = this.userGroupSystemModuleFormData[x];
        selectedActions[data['system_module_id']] = data.selected_actions.split('|');
        x++;
      }
      this.selectedActions = selectedActions;
    }
  },

  async created() {
    await this.getCardAssignmentFeature();
    await this.getCardSellingFeature();
    await this.setFormData();
    this.filterModules();
    if(this.account.account_name.toLowerCase() == 'super8') {
      let disabledModuleDirectAssignment = [
        ...this.disabledModuleDirectAssignment,
        'CardSellingType'
      ];
      this.disabledModuleDirectAssignment = disabledModuleDirectAssignment;
    }
  },

  computed: {
    filteredSystemModules() {
      let systemModules = this.systemModules;
      if(this.hasCardAssignmentModule) {
        systemModules = this.systemModules.filter((element) => !this.disabledModuleDirectAssignment.includes(element.name))
      }
      return systemModules;
    },
    isAllModulesSelected() {
      return this.filteredSystemModules.every((module) => {
        const actions = module.actions.split('|');
        const selected = this.selectedActions[module.id] || [];
        return selected.length === actions.length;
      });
    },
    account() {
      return this.$store.state.account;
    },
  },

  watch: {
    userGroupData: function (newVal) {
      if (newVal !== null) {
        this.setFormData();
      } else {
        this.clearForm();
      }
    },

    drawerVisible: function (val) {
      if (val == false) {
        this.closeDrawer();
      }
    },

    activeKey(key) {
      console.log(key);
    }
  }
};
</script>

<style scoped></style>
